/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ list: NonNullable<unknown>, saved: NonNullable<unknown> }} Receipt_Discount_Note_PlainInputs */



/**
* | output |
* | --- |
* | "Prices include partner discounts · list price {list} · saved {saved}" |
*
* @param {Receipt_Discount_Note_PlainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_discount_note_plain = /** @type {((inputs: Receipt_Discount_Note_PlainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Discount_Note_PlainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Preise inkl. Partnerrabatten · Listenpreis ${i?.list} · gespart ${i?.saved}`)
	return /** @type {LocalizedString} */ (`Prices include partner discounts · list price ${i?.list} · saved ${i?.saved}`)
});